<template>
  <transition name="icp-dialog-fade">
    <div v-if="visible" class="icp-dialog" @click.self="handleClose">
      <div class="panel" role="dialog" aria-modal="true" aria-label="ICP备案信息">
        <button type="button" class="close" aria-label="关闭ICP备案号弹窗" @click="handleClose">
          <img src="../../../assets/home-confirm/dialogs/contact-close.svg" alt="" class="close-icon" />
        </button>
        <p class="title">{{ title }}</p>
        <p class="paragraph">{{ icpNumberText }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "IcpDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "ICP备案信息",
    },
    icpNumber: {
      type: String,
      default: "京ICP备12345678号-1",
    },
  },
  computed: {
    icpNumberText() {
      return String(this.icpNumber || "").trim() || "暂无备案信息";
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.icp-dialog {
  position: fixed;
  inset: 0;
  z-index: 1997;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.55);
}

.panel {
  position: relative;
  box-sizing: border-box;
  width: min(720px, calc(100vw - 48px));
  padding: 28px 32px 26px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.18);
}

.close {
  position: absolute;
  top: 14px;
  right: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 0;
  padding: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.close:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.35);
  outline-offset: 2px;
}

.close:hover {
  background: rgba(0, 0, 0, 0.04);
}

.close-icon {
  width: 16px;
  height: 16px;
}

.title {
  margin: 0;
  padding: 0 40px;
  color: #111111;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
}

.paragraph {
  margin: 16px 0 0;
  color: #111111;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
}

.icp-dialog-fade-enter-active,
.icp-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.icp-dialog-fade-enter-active .panel,
.icp-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.icp-dialog-fade-enter,
.icp-dialog-fade-enter-from,
.icp-dialog-fade-leave-to {
  opacity: 0;
}

.icp-dialog-fade-enter .panel,
.icp-dialog-fade-enter-from .panel,
.icp-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
<style scoped src="./IcpDialog.mobile.css"></style>
